import { render, staticRenderFns } from "./Drafter.vue?vue&type=template&id=87ca120c&scoped=true&"
import script from "./Drafter.vue?vue&type=script&lang=js&"
export * from "./Drafter.vue?vue&type=script&lang=js&"
import style0 from "./Drafter.vue?vue&type=style&index=0&id=87ca120c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ca120c",
  null
  
)

export default component.exports